import api from './api';

/**
 * Rapor servisi
 */
const reportService = {
  /**
   * Rezervasyon raporu getir
   * @param {Object} filters - Filtreleme parametreleri
   * @returns {Promise} Rezervasyon raporu
   */
  getReservationReport: (filters) => {
    return api.get('/reports/reservations', { params: filters });
  },

  /**
   * Operasyon raporu getir
   * @param {Object} filters - Filtreleme parametreleri
   * @returns {Promise} Operasyon raporu
   */
  getOperationReport: (filters) => {
    return api.get('/reports/operations', { params: filters });
  },

  /**
   * Finansal rapor getir
   * @param {Object} filters - Filtreleme parametreleri
   * @returns {Promise} Finansal raporu
   */
  getFinancialReport: (filters) => {
    return api.get('/reports/financial', { params: filters });
  },

  /**
   * Acente performans raporu getir
   * @param {Object} filters - Filtreleme parametreleri
   * @returns {Promise} Acente raporu
   */
  getAgencyReport: (filters) => {
    return api.get('/reports/agencies', { params: filters });
  },

  /**
   * Taşımacı performans raporu getir
   * @param {Object} filters - Filtreleme parametreleri
   * @returns {Promise} Taşımacı raporu
   */
  getCarrierReport: (filters) => {
    return api.get('/reports/carriers', { params: filters });
  },

  /**
   * Araç kullanım raporu getir
   * @param {Object} filters - Filtreleme parametreleri
   * @returns {Promise} Araç raporu
   */
  getVehicleReport: (filters) => {
    return api.get('/reports/vehicles', { params: filters });
  },

  /**
   * Bölge bazlı rapor getir
   * @param {Object} filters - Filtreleme parametreleri
   * @returns {Promise} Bölge raporu
   */
  getRegionReport: (filters) => {
    return api.get('/reports/regions', { params: filters });
  },

  /**
   * Dashboard özet raporu getir
   * @param {Object} filters - Filtreleme parametreleri
   * @returns {Promise} Dashboard raporu
   */
  getDashboardReport: (filters) => {
    return api.get('/reports/dashboard', { params: filters });
  },

  /**
   * Rapor dışa aktar
   * @param {Object} data - Rapor verileri
   * @returns {Promise} Dışa aktarılan rapor
   */
  exportReport: (data) => {
    return api.post('/reports/export', data, {
      responseType: 'blob'
    });
  }
};

export default reportService;